<template>
  <div>
    <h2>{{ global.type == 'manage' ? '管理端' : '客户端' }}</h2>
    <div class="info_box">
      <div class="kaka-btn">
        <el-button type="success" size="small" icon="el-icon-brush" @click="toKaka">月亮湾设计智能体</el-button>
      </div>
      <div class="name">
        <el-button type="text" disabled>{{ username }}</el-button>
      </div>
      <div class="avatar">
        <el-button type="text" @click="toExit">退出登录</el-button>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: 'HeaderComponent',
  data() {
    return {
      visible: false,
      phone: '',
      username: ''
    }
  },
  mounted() {
    // let _phone = localStorage.getItem('phone')
    // console.log(_phone)
    // if(_phone){
    //   this.phone = _phone
    // }
    let _username = localStorage.getItem('username')
    console.log(_username)
    if(_username){
      this.username = _username
    }
  },
  methods: {
    toKaka() {
      this.$router.push('/kaka')
    },
    toExit() {
      let _this = this
      this.$confirm('确定退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const _url = "/api/?mod=login&action=logout"
        this.axios.post(_url).then(json => {
          // 获取
          let _data = json.data.data
          console.log("logout", _data);
          if (json.data.errcode == 0) {
            this.$message({
              type: 'success',
              message: '退出成功!',
              center: true,
              offset: 300,
              duration: 500,
              onClose: function() {
                localStorage.removeItem('sessionId');
                _this.global.clientId = ''
                _this.global.clientName = ''
                _this.$router.replace('/login')
                // window.location.href = '/login'
              }
            });
          }
          console.log(json.data);
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });          
      });
    },
  }
}
</script>
  
<style scoped lang="less">
.header {
  z-index: 2001;
  h2 {
    height: 40px;
    margin-top: 8px;
    margin-bottom: 12px;
    padding-left: 50px;
    color: rgba(51,51,51,1);
    font-size: 28px;
    font-weight: 400;
    line-height: 40px;
    box-sizing: border-box;
    background: url(../assets/ico_guanli.jpg) no-repeat;
    background-position: 15px 5px;
    background-size: 30px 30px;
  }
  .info_box {
    position: absolute;
    top: 10px;
    right: 8px;
    font-size: 0;
    .avatar {
      display: inline-block;
      height: 36px;
      img {
        width: 36px;
        height: 36px;
      }
    }
    .name {
      display: inline-block;
      margin-right: 10px;
      .el-button--text {
        color: rgba(51,51,51,1)
      }
    }
    .kaka-btn {
      display: inline-block;
      margin-right: 10px;
      vertical-align: middle;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/HeaderComponent.vue